var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '../elements/index';
import { CircularProgress } from '@material-ui/core';
/* tslint:disable */
const TextButton = props => {
    const { className, loading, blue, children, icon, secondary, small, focused, grey, iconReversed } = props, rest = __rest(props, ["className", "loading", "blue", "children", "icon", "secondary", "small", "focused", "grey", "iconReversed"]);
    const classNames = classnames('TextButton', { 'TextButton--secondary': secondary }, { 'TextButton--blue': blue }, { 'TextButton--loading': loading }, { 'TextButton--small': small }, { 'TextButton--focused': focused }, { 'TextButton--grey': grey }, className);
    return (React.createElement(Button, Object.assign({ className: classNames }, rest),
        loading &&
            React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px' } },
                React.createElement(CircularProgress, { style: { color: '#009B48' }, size: 35 })),
        React.createElement("div", { style: loading ? { visibility: 'hidden', height: 0 } : { height: '100%' } },
            icon && !iconReversed &&
                React.createElement("div", { style: { display: 'flex', height: '100%' } },
                    React.createElement("div", { style: { alignItems: 'center', display: 'flex' } }, icon),
                    React.createElement("div", { style: { alignItems: 'center', display: 'flex' } }, children)),
            icon && iconReversed &&
                React.createElement("div", { style: { display: 'flex', height: '100%' } },
                    React.createElement("div", { style: { alignItems: 'center', display: 'flex' } }, children),
                    React.createElement("div", { style: { alignItems: 'center', display: 'flex' } }, icon)),
            !icon &&
                children)));
};
export default TextButton;
